import React, { useState } from 'react';
import { Popover, Card, ListGroup, OverlayTrigger, Button as RBButton } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export default function CostFieldsPopover(_ref) {
  let {
    selectedFields,
    setSelectedFields
  } = _ref;
  const allFields = window.MARKET_CONSTANTS.COST_EXPORT_FIELDS_LIST;
  const {
    t
  } = useTranslation();
  const [isAllSelected, setIsAllSelected] = useState(selectedFields.length === allFields.length);
  const toggleAll = () => {
    if (isAllSelected) {
      setSelectedFields([]);
    } else {
      setSelectedFields(allFields);
    }
    setIsAllSelected(!isAllSelected);
  };
  const toggleField = field => {
    if (selectedFields.includes(field)) {
      setSelectedFields(selectedFields.filter(f => f !== field));
    } else {
      setSelectedFields([...selectedFields, field]);
    }
  };
  const popover = /*#__PURE__*/React.createElement(Popover, {
    id: "popover-cost-fields",
    className: "project-fields-selector-container"
  }, /*#__PURE__*/React.createElement(Card, {
    className: "p-2 project-fields-selector-card",
    style: {
      maxHeight: '400px',
      overflowY: 'auto'
    }
  }, /*#__PURE__*/React.createElement(ListGroup, {
    defaultActiveKey: "all"
  }, /*#__PURE__*/React.createElement(ListGroup.Item, {
    className: "project-fields-item mb-1",
    active: isAllSelected,
    key: "all",
    action: true,
    onClick: toggleAll
  }, t('all')), allFields.map(field => /*#__PURE__*/React.createElement(ListGroup.Item, {
    className: "project-fields-item mb-1",
    active: selectedFields.includes(field),
    key: field,
    action: true,
    onClick: () => toggleField(field)
  }, t(field))))));
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    trigger: "click",
    rootClose: true,
    overlay: popover
  }, /*#__PURE__*/React.createElement(RBButton, {
    style: {
      width: '240px'
    },
    variant: "primary",
    className: "me-4"
  }, t('cost_fields')));
}